let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("e365F")).then(() => parcelRequire('l5bNB'));